export default "__VITE_ASSET__D9m_yVIt__"